import { globalServices } from "../Axios/GlobalService";
import { ServiceUrl } from "../Helpers/Constants";
import { SPGetDocuments } from "../Interfaces/SPGetDocuments";
import { SPUploadFile } from "../Interfaces/SPUploadFile";
import { SharepointDocument } from "../Interfaces/SharepointDocument";

export const SharepointService = {
    getDocuments,
    downloadFile,
    uploadFile
}

function getDocuments(request:SPGetDocuments) {
    return globalServices.post<SharepointDocument[]>(
        `${ServiceUrl}Sharepoint/Documents`,request
    );
}
function downloadFile(site: string, path: string) {
    return globalServices.get<string>(
        `${ServiceUrl}Sharepoint/DownloadFile?site=${site}&path=${path}`
    );
}
function uploadFile(request: SPUploadFile) {
    return globalServices.post(
        `${ServiceUrl}Sharepoint/UploadFile`, request
    );
}